<template>
  <h1>Equipo Profesional</h1>
</template>
